export class LogPatternModel {
    text;
    id;
    highlights;
}
//# sourceMappingURL=log-pattern.js.map